var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import * as models from '@/models';
import * as utils from '@/utils';
let NotificationSettings = class NotificationSettings extends Vue {
    constructor() {
        super(...arguments);
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        this.settings = null;
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        this.error = null;
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        this.loadingSettings = {};
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        this.saveSettingsErrors = {};
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        this.baseId = `notification-settings-${utils.getUniqueId()}`;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get loading() {
        return this.settings == null;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    created() {
        this.load();
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    async load() {
        this.settings = null;
        this.error = null;
        try {
            this.settings = await models.NotificationSettings.loadFromServer(this.token);
        }
        catch (e) {
            this.error = utils.coerceToError(e);
        }
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    async updateSetting(setting, newValue) {
        this.$set(this.loadingSettings, setting.reason, true);
        try {
            await utils.waitAtLeast(250, setting.updateValue(newValue, this.token));
        }
        catch (e) {
            this.$set(this.saveSettingsErrors, setting.reason, e);
            await this.$nextTick();
        }
        this.$set(this.loadingSettings, setting.reason, false);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    hideError(setting) {
        this.$delete(this.saveSettingsErrors, setting.reason);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    showSelect(setting) {
        const reason = setting.reason;
        return this.saveSettingsErrors[reason] == null && !this.loadingSettings[reason];
    }
};
__decorate([
    Prop({ default: null, type: String })
], NotificationSettings.prototype, "token", void 0);
NotificationSettings = __decorate([
    Component
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
], NotificationSettings);
export default NotificationSettings;
